import { useState, useEffect, useMemo } from "react";

function TypingMain() {
  const typingArray = useMemo(
    () => [
      "당신도 놀랄 운명의 사랑이",
      "인생을 바꿀 특별한 제안이",
      "당신이 원하던 큰돈을 벌 기회가",
      "피할 수 없는 위험한 상황이",
      "일생일대 성공의 기회가",
      "평생 잊지 못할 인생의 사건이",
    ],
    []
  );

  const [text, setText] = useState("");
  const [index, setIndex] = useState(0); // 현재 배열 인덱스
  const [charIndex, setCharIndex] = useState(0); // 글자 인덱스
  const [isDeleting, setIsDeleting] = useState(false); // 지우는 중 여부

  useEffect(() => {
    const currentText = typingArray[index];

    let timeout: ReturnType<typeof setTimeout> | undefined;

    if (isDeleting) {
      // 백스페이스 효과 (한 글자씩 지우기)
      if (text.length > 0) {
        timeout = setTimeout(() => {
          setText((prev) => prev.slice(0, -1));
          setCharIndex((prev) => prev - 1);
        }, 25); // 지울 때 속도 조절
      } else {
        // 모든 글자가 지워지면 다음 문장으로 변경
        setIsDeleting(false);
        setCharIndex(0);
        setIndex((prev) => (prev + 1) % typingArray.length); // 다음 문장으로 변경 (무한 반복)
      }
    } else {
      // 타이핑 효과 (한 글자씩 추가)
      if (charIndex < currentText.length) {
        timeout = setTimeout(() => {
          setText((prev) => prev + currentText[charIndex]);
          setCharIndex((prev) => prev + 1);
        }, 70); // 타이핑 속도 조절
      } else {
        // 모든 글자가 입력되면 1초 대기 후 삭제 시작
        timeout = setTimeout(() => setIsDeleting(true), 1000);
      }
    }

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [text, isDeleting, charIndex, index, typingArray]);

  return (
    <>
      <div className="typing typing_main_title" style={{ marginTop: "24px" }}>
        놀라지 마세요!
      </div>
      <div className="typing typing_main">
        <span className="typing_target">{text}</span>
        <span className="typing_suffix">찾아옵니다.</span>
      </div>
    </>
  );
}

export default TypingMain;
